<template>
    <v-container v-resize="onResize">
        <v-layout v-if="!loading" row wrap pt-4 align-center>
            <v-flex xs12>
                <h2>Shadow Ministers in the {{this.Name}} {{ this.DATE_FROMTO( this.ShadowMinistryStart , this.ShadowMinistryEnd )  }}</h2>
            </v-flex>
            <v-flex xs12 md8>
                <statistical-member-or-senator-selector :value="selectedMpOrSenator" @input="selectedMpOrSenator = $event" />
            </v-flex>
            <v-flex xs12 md4>
                <div>
                    <v-text-field :class="{mobileTextField: isMobile}"  v-if="!this.loading" v-on:keyup="TRACK_SEARCH" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    <v-menu v-if="!this.loading && this.isMobile" d-inline offset-y :nudge-left="140" :close-on-content-click="true">
                        <v-btn outline small slot="activator">
                            Sort <v-icon>sort</v-icon>
                        </v-btn>
                        <v-list>
                            <v-subheader>Sort by:</v-subheader>
                            <v-list-tile v-for="(item, index) in HEADERS.filter(h => h.text != '' && h.sortable != false)" :key="item.value" @click="changeSort(item.value)">
                                <v-list-tile-title>
                                    {{ item.text }}
                                    <v-icon v-if="PAGINATION.sortBy === item.value">{{PAGINATION.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                                </v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </div>
            </v-flex>
        </v-layout>

        <template>
            <v-card v-if="loading">
                <v-container fluid>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <div class="loader"></div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </template>
        <br>
        <div v-show="!loading">
            <v-data-table :items="this.SHADOWMINISTRY"
                        :headers="HEADERS"
                        :rows-per-page-items="ROWS_LISTITEMS"
                        v-on:update:pagination="UPDATE_PAGINATION"
                        :pagination.sync="PAGINATION"
                        :search="search"
                        :hide-headers="isMobile"
                        :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                        disable-initial-sort>

                <template v-slot:items="props">
                    <router-link v-if="isMobile" class="tr" :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.PHID }}" >
                        <td>
                            <div class="flex-content">
                                <div class="flex-item">
                                    <h3 class="pb-xs-1">{{ props.item.DisplayName }}</h3>
                                </div>
                                <div class="flex-item flex-item-col flex-item-col-30">
                                    <div class="flex-item">
                                        <Portrait v-bind:PHID="props.item.PHID" :fixedWidth="80"></Portrait>
                                    </div>
                                </div>
                                <div class="flex-item flex-item-col flex-item-col-70">
                                    <h4>Portfolio</h4>
                                    <ul>
                                    <li v-for="splitRole in props.item.SplitRoles" class="pt-1">
                                        {{ splitRole.FullRole }} ({{ splitRole.DateStart }}–{{ splitRole.DateEnd != '' ? splitRole.DateEnd : 'present' }})
                                    </li></ul>
                                </div>
                                <div class="flex-item" data-label="Member or Senator">
                                    {{ props.item.MPorSenator }}
                                </div>
                            </div>
                        </td>
                    </router-link>
                    <router-link v-else :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.PHID }}" class="tr handbook-tablerow_link">
                        <td class="text-xs-left"><Portrait v-bind:PHID="props.item.PHID" :fixedWidth="80"></Portrait></td>
                        <td class="text-xs-left">{{ props.item.DisplayName }}</td>
                        <td class="text-xs-left handbook-tablecol_linebreaks" style="white-space: break-spaces;">{{ props.item.FullRole }}</td>
                        <td class="text-xs-left handbook-tablecol_linebreaks">{{ props.item.DateStart }}</td>
                        <td class="text-xs-left handbook-tablecol_linebreaks">{{ props.item.DateEnd }}</td>
                        <td class="text-xs-left">{{ props.item.MPorSenator }}</td>
                    </router-link>
                </template>

                <template v-slot:no-results>
                    <v-alert :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                    </v-alert>
                </template>
            </v-data-table>
            <v-layout row wrap>
                <v-flex xs12>
                    <div style="float:right">
                        <v-btn v-on:keyup.enter="EXPORT_SHADOWMINISTRY_PDF" color="primary">
                            <v-icon aria-hidden="true" :class="pdfDownloadClass">{{pdfDownloadIcon}}</v-icon>
                            <span v-on:click="EXPORT_SHADOWMINISTRY_PDF">&nbsp;Download as PDF</span>
                        </v-btn>
                        <v-btn v-on:keyup.enter="EXPORT_SHADOWMINISTRY_CSV" color="primary">
                            <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                            <span v-on:click="EXPORT_SHADOWMINISTRY_CSV">&nbsp;Download as CSV</span>
                        </v-btn>
                    </div>
                </v-flex>
            </v-layout>
        </div>

    </v-container>
</template>

<script>
    window.scrollTo(0, 0);
    import Portrait from '@/components/Portrait.vue'
    import axios from 'axios'
    import StatisticalMemberOrSenatorSelector from '@/views/StatisticalInformation/StatisticalMemberOrSenatorSelector.vue';

    export default {
        data() {
            return {
                isMobile: false,
                loading: true,
                search: '',
                pdfDownloading: false,
                csvDownloading: false,
                THISSHADOWMINISTRY: null,
                shadowMinistryRecords:[],
                shadowMinistryRecordsBackup:[],
                selectedMpOrSenator: ['senator', 'mp'],
                ROWS_LISTITEMS: [5, 10, 50, {
                    "text": "$vuetify.dataIterator.rowsPerPageAll",
                    "value": -1
                }],

                PAGINATION: {
                    rowsPerPage: this.$store.state.ROWS_PER_PAGE
                },

                HEADERS: [
                    {
                        text: '',
                        value: 'DisplayName',
                        sortable: false,
                        align: 'left'
                    },
                    {
                        text: 'Shadow Minister',
                        value: 'DisplayName',
                        sortable: true,
                        align: 'left'
                    },
                    {
                        text: 'Portfolio',
                        align: 'left',
                        sortable: true,
                        value: 'FullRole'
                    },
                    {
                        text: 'Start Date',
                        value: 'DateStart',
                        align: 'left',
                        sortable: true,

                    }
                    ,
                    {
                        text: 'End Date',
                        value: 'DateEnd',
                        align: 'left',
                        sortable: true,

                    },
                    {
                        text: 'Member or Senator',
                        value: 'MPorSenator',
                        align: 'left',
                        sortable: true
                    },
                ]
            }
        },

        props: {
            SMID: {
                type: Number,
                required: true,
            }
        },
        watch: {
            selectedMpOrSenator: function () {
                if (this.selectedMpOrSenator.length == 1) {
                    const selected = this.selectedMpOrSenator[0];
                    switch (selected) {
                        case 'senator':
                            this.shadowMinistryRecords = this.shadowMinistryRecordsBackup.filter(m => m.MPorSenator == "Senator");
                            break;
                        case 'mp':
                            this.shadowMinistryRecords = this.shadowMinistryRecordsBackup.filter(m => m.MPorSenator == "Member");
                    }
                }
                else {
                    this.shadowMinistryRecords = this.shadowMinistryRecordsBackup;
                }
            }
        },
        components: {
            Portrait,
            StatisticalMemberOrSenatorSelector
        },
        created() {
            this.loadShadowMinistry();
        },
        mounted() {
            this.onResize();
            //Set page to 10 on mobile, only on mount
            if (this.isMobile){
                this.PAGINATION.rowsPerPage = 10;
            }
        },
        methods: {
            onResize() {
                if (window.innerWidth < 769){
                    this.isMobile = true;
                }
                else{
                    this.isMobile = false;
                }
            },
            changeSort(column) {
                if (this.PAGINATION.sortBy === column) {
                    this.PAGINATION.descending = !this.PAGINATION.descending
                } 
                else {
                    this.PAGINATION.sortBy = column
                    this.PAGINATION.descending = false
                }
            },
            loadShadowMinistry() {
                this.loading = true;
                const url = `shadowministries?$filter=SMID%20eq%20${this.SMID}&$select=SMID,SMIDOrdinal,Name,DateStart,DateEnd`;
                const recordUrl = `shadowministryrecords?$filter=SMID%20eq%20${this.SMID}`;
                const ministryRequest = axios.get(`api/${url}`)
                const ministryRecordsRequest = axios.get(`api/${recordUrl}`);
                axios.all([ministryRequest, ministryRecordsRequest])
                    .then(response => {
                        this.THISSHADOWMINISTRY = response[0].data.value[0];
                        this.shadowMinistryRecords = response[1].data.value;
                        this.shadowMinistryRecordsBackup = response[1].data.value;
                        this.loading = false;
                        if (this.THISSHADOWMINISTRY != null){
                            window.document.title = this.THISSHADOWMINISTRY.Name;   
                        }
                    });
            },
            TRACK_SEARCH: function () {
                if (this.search.length >= 3) {
                    this.$gtag.event('filter shadow ministry members - search', {
                        'event_category': 'filters',
                        'event_label': this.search,
                        'value': 1
                    });
                }
            },

            UPDATE_PAGINATION: function (options) {
                this.$gtag.event('shadow ministry members pagination items per page', {
                    'event_category': 'filters',
                    'event_label': `items per page: ${options.rowsPerPage}`,
                    'value': 1
                });
                this.$gtag.event('shadow ministry members pagination page', {
                    'event_category': 'filters',
                    'event_label': `page: ${options.page}`,
                    'value': 1
                });
                this.$gtag.event(`shadow ministry members sorting`, {
                    'event_category': 'sorting',
                    'event_label': `sort by ${options.sortBy} ${options.descending ? 'DESC' : 'ASC'}`,
                    'value': 1
                });
                return this.PAGINATION;
            },
            DATE_FROMTO(DateFrom, DateTo) {
                if (DateFrom && DateFrom != 'undefined' && DateFrom != 'Undefined' && DateFrom != '1900-01-01' && DateFrom != '1900-01-1') {
                    DateFrom = ' from ' + this.$moment(String(DateFrom)).format('DD.MM.YYYY')
                } else {
                    DateFrom = ''
                }
                if (DateTo && DateTo != 'undefined' && DateTo != 'Undefined' && DateTo != '1900-01-01' && DateTo != '1900-01-1') {
                    DateTo = ' to ' + this.$moment(String(DateTo)).format('DD.MM.YYYY')
                } else {
                    DateTo = ''
                }
                return DateFrom + DateTo
            },
            EXPORT_SHADOWMINISTRY_CSV: function () {
                this.$gtag.event('shadow ministry download csv', {
                    'event_category': 'downloads',
                    'event_label': `shadow ministry ${this.Name} csv download`,
                    'value': 1
                });

                this.csvDownloading = true;

                let thisShadowMinistry = this.shadowMinistryRecords.map(sm => ({ ...sm, FullRole: `${sm.Role}${sm.Prep !== '' ? ` ${sm.Prep} ${sm.Entity}` : ''}` }))
                let OBJ_records = [];
                let headers = ['Name', 'PHID', 'Portfolio', 'Start Date', 'End Date', 'Member or Senator'];
                let filename = `[${this.SMID}] ${this.Name}`
                let index = 0;

                //  then we progressively build up the  exportOBJ
                for (index = 0; index < thisShadowMinistry.length; ++index) {
                    OBJ_records.push({
                        'Name': thisShadowMinistry[index].DisplayName,
                        'PHID': thisShadowMinistry[index].PHID,
                        'Portfolio': thisShadowMinistry[index].FullRole,
                        'Start Date': this.formatDate(thisShadowMinistry[index].RDateStart, '', 'YYYY-MM-DD', false),
                        'End Date': this.formatDate(thisShadowMinistry[index].RDateEnd, '', 'YYYY-MM-DD', false),
                        'Member or Senator': thisShadowMinistry[index].MPorSenator
                    });
                }
                this.$store.dispatch('GETCSV', { DATA: OBJ_records, HEADERS: headers, FILENAME: filename })
                    .catch(this.showError)
                    .finally(() => this.csvDownloading = false);
                thisShadowMinistry = null;
                OBJ_records = null;
                index = null;
            },
            EXPORT_SHADOWMINISTRY_PDF: function () {
                this.$gtag.event('shadow ministry download pdf', {
                    'event_category': 'downloads',
                    'event_label': `shadow ministry ${this.Name} pdf download`,
                    'value': 1
                });
                
                this.pdfDownloading = true;

                let url = `${this.$store.state.URL_API}/document/shadowministry`;

                let shadowMinistryStart = this.ShadowMinistryStart ? this.$moment(this.ShadowMinistryStart).format('DD.MM.YYYY') : '';
                let shadowMinistryEnd = this.ShadowMinistryEnd ? this.$moment(this.ShadowMinistryEnd).format('DD.MM.YYYY') : '';

                let shadowMinistryModel = { SMID: this.SMID, Name: this.Name, ShadowMinistryStart: shadowMinistryStart, ShadowMinistryEnd: shadowMinistryEnd, ShadowMinistry: this.SHADOWMINISTRY }

                axios.post(url, shadowMinistryModel, { responseType: 'arraybuffer' })
                    .then((response) => {
                        let blob = new Blob([response.data], { type: 'application/pdf' }),
                            downloadUrl = window.URL.createObjectURL(blob),
                            filename = `Shadow Ministry [${this.Name}].pdf`

                        let a = document.createElement("a");
                        if (typeof a.download === "undefined") {
                            window.location.href = downloadUrl;
                        } else {
                            a.href = downloadUrl;
                            a.download = filename;
                            document.body.appendChild(a);
                            a.click();
                        }
                        a.remove();
                    }).catch(this.showError)
                    .finally(() => this.pdfDownloading = false);
            }
        },

        computed: {
            SHADOWMINISTRY: function () {
                if (this.loading) {
                    return [];
                }
                var shadowMinistry = this.shadowMinistryRecords.map(m => ({ ...m, FullRole: `${m.Role}${m.Prep !== '' ? ` ${m.Prep} ${m.Entity}` : ''}` }));
                var consolidatedShadowMinistry = [];

                var first = undefined;
                let aggregateRole = undefined;
                let aggregateDateStart = undefined;
                let aggregateDateEnd = undefined;
                let arrayRoles = [];
                for (var i = 0; i < shadowMinistry.length; i++) {
                    if (!first) {
                        first = shadowMinistry[i];
                        aggregateRole = first.FullRole;
                        aggregateDateStart = this.formatDate(first.RDateStart, null, null, false);
                        aggregateDateEnd = this.formatDate(first.RDateEnd, null, null, false);
                        arrayRoles.push({ FullRole: first.FullRole, DateStart: this.formatDate(first.RDateStart, null, null, false), DateEnd: this.formatDate(first.RDateEnd, null, null, false) });
                    } else {
                        if (i === shadowMinistry.length - 1) {
                            if (first.PHID !== shadowMinistry[i].PHID) {
                                let lastmin = { ...first, FullRole: aggregateRole, DateStart: aggregateDateStart, DateEnd: aggregateDateEnd, SplitRoles: arrayRoles };
                                consolidatedShadowMinistry.push(lastmin);
                                arrayRoles = [];
                                first = shadowMinistry[i];
                                aggregateRole = first.FullRole;
                                aggregateDateStart = this.formatDate(first.RDateStart, null, null, false);
                                aggregateDateEnd = this.formatDate(first.RDateEnd, null, null, false);
                                arrayRoles.push({ FullRole: first.FullRole, DateStart: this.formatDate(first.RDateStart, null, null, false), DateEnd: this.formatDate(first.RDateEnd, null, null, false) });
                                //push current instance
                                consolidatedShadowMinistry.push({ ...shadowMinistry[i], FullRole: aggregateRole, DateStart: aggregateDateStart, DateEnd: aggregateDateEnd, SplitRoles: arrayRoles });
                                arrayRoles = [];
                            } else {
                                if (!aggregateRole.includes(shadowMinistry[i].FullRole)) {
                                    aggregateRole = `${aggregateRole}\n${shadowMinistry[i].FullRole}`;
                                    aggregateDateStart = `${aggregateDateStart}\n${this.formatDate(shadowMinistry[i].RDateStart, null, null, false)}`;
                                    aggregateDateEnd = `${aggregateDateEnd}\n${this.formatDate(shadowMinistry[i].RDateEnd, null, null, false)}`;
                                    arrayRoles.push({ FullRole: shadowMinistry[i].FullRole, DateStart: this.formatDate(shadowMinistry[i].RDateStart, null, null, false), DateEnd: this.formatDate(shadowMinistry[i].RDateEnd, null, null, false) });
                                }
                                consolidatedShadowMinistry.push({ ...first, FullRole: aggregateRole, DateStart: aggregateDateStart, DateEnd: aggregateDateEnd, SplitRoles: arrayRoles });
                                arrayRoles = [];
                            }
                        } else {
                            if (first.PHID !== shadowMinistry[i].PHID) {
                                var min = { ...first, FullRole: aggregateRole, DateStart: aggregateDateStart, DateEnd: aggregateDateEnd, SplitRoles: arrayRoles };
                                consolidatedShadowMinistry.push(min);
                                arrayRoles = [];
                                first = shadowMinistry[i];
                                aggregateRole = first.FullRole;
                                aggregateDateStart = this.formatDate(first.RDateStart, null, null, false);
                                aggregateDateEnd = this.formatDate(first.RDateEnd, null, null, false);
                                arrayRoles.push({ FullRole: first.FullRole, DateStart: this.formatDate(first.RDateStart, null, null, false), DateEnd: this.formatDate(first.RDateEnd, null, null, false) });
                            } else {
                                if (!aggregateRole.includes(shadowMinistry[i].FullRole)) {
                                    aggregateRole = `${aggregateRole}\n${shadowMinistry[i].FullRole}`;
                                    aggregateDateStart = `${aggregateDateStart}\n${this.formatDate(shadowMinistry[i].RDateStart, null, null, false)}`;
                                    aggregateDateEnd = `${aggregateDateEnd || ' '}\n${this.formatDate(shadowMinistry[i].RDateEnd, null, null, false) || ' '}`;
                                    arrayRoles.push({ FullRole: shadowMinistry[i].FullRole, DateStart: this.formatDate(shadowMinistry[i].RDateStart, null, null, false), DateEnd: this.formatDate(shadowMinistry[i].RDateEnd, null, null, false) });
                                }
                            }
                        }
                    }
                }
                consolidatedShadowMinistry = this._.orderBy(consolidatedShadowMinistry, [m => m.SplitRoles.findIndex(r => r.FullRole === 'Leader of the Opposition'), m => m.RDateStart], ['desc', 'asc'])
                return consolidatedShadowMinistry;
            },
            Name: function () {
                if (this.THISSHADOWMINISTRY) {
                    return this.THISSHADOWMINISTRY.Name;
                } else {
                    return '';
                }
            },
            ShadowMinistryStart: function () {
                if (this.THISSHADOWMINISTRY) {
                    return this.THISSHADOWMINISTRY.DateStart;
                } else {
                    return '';
                }
            },
            ShadowMinistryEnd: function () {
                if (this.THISSHADOWMINISTRY) {
                    return this.THISSHADOWMINISTRY.DateEnd;
                } else {
                    return '';
                }
            },
            pdfDownloadIcon(){
                return this.pdfDownloading ? 'cached' : 'picture_as_pdf';
            },
            pdfDownloadClass(){
                let pdfClass = 'mr-1';
                if (this.pdfDownloading){
                    pdfClass = pdfClass + ' loading'
                }
                return pdfClass;
            },
            csvDownloadIcon(){
                return this.csvDownloading ? 'cached' : 'text_snippet';
            },
            csvDownloadClass(){
                let csvClass = 'mr-1';
                if (this.csvDownloading){
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            }
        },
    }</script>
<style scoped>
    a {
        color: #fff;
        text-decoration: none;
    }

    td.handbook-tablecol_linebreaks {
        white-space: pre;
    }

    tr.handbook-tablerow_link {
        cursor: pointer;
    }

    .v-datatable .tr {
        display:table-row;
    }

    .v-datatable a.tr {
        color: #0e1531de;
        text-decoration:none;
        border: 1px solid #dbdbdb;
        border-left: none;
        border-right: none;
    }

    .v-datatable tbody td {
        vertical-align: middle;
    }
</style>

